/*SYSTEM IMPORTS*/
    import React, { PureComponent } from 'react'

/*VIEWS*/
    import Breadcrumb from 'containers/Layout/Page/Breadcrumb'
    import Widgets from 'containers/Widgets'
    import MainLayout from 'containers/Layout/MainLayout'

/*HELPERS*/
    import Ratio from 'mixins/Ratio'

    import { ConnectReduxWith } from 'helpers/Redux/connectRedux'
    import { getValue } from 'helpers/Objects'

@ConnectReduxWith( 'settings' )
@Ratio
class NotFound extends PureComponent {
    static defaultProps = {
        settings: {
            not_found_data: {
                title: "404",
                content: []
            }
        },
        actions: {
            Ui: {
                open_not_found: () => console.warn("Action not connect to component"),
                close_not_found: () => console.warn("Action not connect to component")
            }
        }
    }

    componentDidMount() {
        const title = getValue(this.props, "settings.not_found_data.title", "404")

        document.title = title

        this.props.actions.Ui.open_not_found()
    }

    componentWillUnmount() {
        this.props.actions.Ui.close_not_found()
    }

    render() {
        const content = getValue(this.props, "settings.not_found_data.content", [])

        return (
            <MainLayout>
                <Breadcrumb list={[
                    { title: "404", link: "/404" }
                ]} />

                <h1>404</h1>
            </MainLayout>
        )
    }
}

export default NotFound